import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/:accountId/forms/layouts',
    name: ROUTES.FORM_LAYOUT_VIEWER,
    component: () => import('../views/forms/FormLayoutViewer.vue'),
    // Takes query param 'type' for form types to load (e.g. 'BUILDERS_RISK')
  },
  {
    path: '/:accountId/forms/layouts/:jsonFormLayoutId',
    name: ROUTES.FORM_LAYOUT_VIEWER_DETAIL,
    component: () => import('../views/forms/FormLayoutSchemas.vue'),
    // Takes query param 'type' for form types to load (e.g. 'BUILDERS_RISK')
  },
  {
    path: '/:accountId/forms/layouts/:level/edit/:formId',
    name: ROUTES.FORM_LAYOUT_EDITOR,
    component: () => import('../views/forms/FormEditorView.vue'),
    // level: 'template' | 'form'. Is the formId for a template or a form?
  },
  {
    path: '/brokerage/:brokerageId/forms/:level/edit/:formId',
    name: ROUTES.FORM_LAYOUT_EDITOR_BROKERAGE,
    component: () => import('../views/forms/FormEditorView.vue'),
    // level: 'template' | 'form'. Is the formId for a template or a form?
  },
  // Create/View a Brokerage Layout
  {
    path: '/admin/brokerage/:brokerCode/forms',
    name: ROUTES.FORM_BROKER_LAYOUTS,
    component: () => import('../views/forms/BrokerLayouts.vue'),
  },
]
